import React from 'react';

export default () => (
  <svg width="30" height="30" viewBox="0 0 31 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15.4764 24.6504L6.04455 29.9801L8.15076 19.2775L0.21402 11.8689L10.9483 10.5837L15.4764 0.674927L20.0044 10.5837L30.7387 11.8689L22.802 19.2775L24.9082 29.9801L15.4764 24.6504ZM15.4764 21.5563L21.1558 24.7652L19.8867 18.3218L24.6648 13.8601L18.2017 13.0866L15.4764 7.12105L12.751 13.0879L6.28793 13.8601L11.066 18.3218L9.79695 24.7652L15.4764 21.5563Z" fill="#FFC700"/>
  </svg>
);
